require("./bootstrap");

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { Inertia } from "@inertiajs/inertia";
import { createStore } from "vuex";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import "@fortawesome/fontawesome-free/css/all.min.css";
import {
    BASE_COLOR_PROGRESS,
    INERTIA_VISIT_START,
    INERTIA_VISIT_STOP,
} from "@/constants";
import { kiloSeparator, formatDate } from "@/functions";
import BadgeDirective from "primevue/badgedirective";
import Tooltip from "primevue/tooltip";

const store = createStore({
    state() {
        return {
            inertiaVisit: null,
            count_page_notifs: null,
        };
    },
    mutations: {
        inertiaStart(state) {
            state.inertiaVisit = INERTIA_VISIT_START;
        },
        inertiaStop(state) {
            state.inertiaVisit = INERTIA_VISIT_STOP;
        },
        setCountPageNotifs(state, payload) {
            state.count_page_notifs = payload.amount;
        },
    },
});

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(PrimeVue, { ripple: true })
            .use(ToastService)
            .use(ConfirmationService)
            .use(store)
            .directive("badge", BadgeDirective)
            .directive("tooltip", Tooltip)
            .mixin({ methods: { route, kiloSeparator, formatDate } })
            .mount(el);
    },
});

Inertia.on("start", () => {
    //
    // console.log('start');
    store.commit("inertiaStart");
});
Inertia.on("finish", () => {
    //
    // console.log('stop');
    store.commit("inertiaStop");
});

// InertiaProgress.init({
//     color: BASE_COLOR_PROGRESS,
//     showSpinner: true,
// });
